import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceOverview = () => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
              Employment & Labor Law Excellence
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary to-accent mx-auto rounded-full"></div>
          </div>

          <div className="space-y-8">
            {/* Main Description */}
            <div className="bg-white rounded-2xl p-8 shadow-md border border-border-light">
              <div className="prose prose-lg max-w-none">
                <p className="text-text-secondary leading-relaxed mb-6">
                  The Employment & Labor Law landscape in Kenya continues to evolve, presenting both opportunities and challenges for employers and employees alike. At Peter & Partners Advocates LLP, we provide comprehensive workplace legal services that help navigate complex labor regulations while protecting your rights and interests.
                </p>
                <p className="text-text-secondary leading-relaxed mb-6">
                  Our approach combines deep understanding of Kenya's labor laws with practical workplace solutions, ensuring that both employers and employees can thrive in productive working relationships. We handle everything from employment contract drafting to complex workplace dispute resolution.
                </p>
                <p className="text-text-secondary leading-relaxed mb-0">
                  Whether you're an employer seeking compliance guidance or an employee protecting your workplace rights, our experienced team provides strategic counsel that achieves favorable outcomes while maintaining professional relationships.
                </p>
              </div>
            </div>

            {/* Key Points */}
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-8 border border-primary/10">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
                    <Icon name="Target" size={24} color="white" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                      Why It Matters
                    </h3>
                    <p className="text-text-secondary leading-relaxed">
                      Employment law is critical for maintaining productive workplaces, protecting worker rights, and ensuring business compliance. Proper legal guidance prevents costly disputes and fosters positive employer-employee relationships.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-secondary/20 to-surface/20 rounded-2xl p-8 border border-secondary/20">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-accent rounded-xl flex items-center justify-center">
                    <Icon name="Compass" size={24} color="white" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                      Our Approach
                    </h3>
                    <p className="text-text-secondary leading-relaxed">
                      We provide both preventive advice and dispute resolution services, helping clients understand their rights and obligations while developing practical solutions for workplace challenges.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOverview;